module.exports = __webpack_public_path__ + "static/multiple-location-shifts-1d3902d58fc042d8f90c20e4adc2117c.png";